import { useMutation } from '@platform/api-client';
import { browserTimeZone } from '@platform/design-system';
import type { ShippingClient } from '@platform/openapi';
import { saveDownload } from '../saveDownload.ts';
import { usePageContext } from '../usePageContext.ts';

export const useVoucherDownload = (shipping: ShippingClient) => {
  const { t, notify } = usePageContext();
  return useMutation({
    mutationFn: (handoverId: string) =>
      shipping.post('/admin/handovers/{id}/voucher-url', {
        path: { id: handoverId },
        body: { timeZone: browserTimeZone() },
      }),
    onSuccess: (signed) => {
      saveDownload(signed.url);
      notify(t('handover.voucherDownloaded'));
    },
  });
};
